<div class="filter-dialog-box">
  @if (!filterOptions?.length) {
    <mat-form-field class="filter-dialog-input">
      <mat-label>{{ 'common.filter.term' | translate }}</mat-label>
      <input matInput type="text" required="false" [formControl]="control" />
    </mat-form-field>
  } @else {
    <mat-form-field class="filter-dialog-input">
      <mat-label>{{ 'common.filter.term' | translate }}</mat-label>
      <mat-select [formControl]="control">
        <mat-option></mat-option>
        @for (entry of filterOptions; track entry) {
          <mat-option [value]="entry.key">{{ entry.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</div>
